document.addEventListener('DOMContentLoaded', function() {
  const productJSON = window.ShopifyAnalytics?.meta?.product || null;
  if (!productJSON) return;
  const variants = productJSON.variants;
  document.querySelectorAll('.variant-input-wrap input, [data-option-value]').forEach(function(el) {
    const label = el.value || el.dataset.optionValue;
    const isAvailable = variants.some(function(v) {
      return v.options.includes(label) && v.available;
    });
    if (!isAvailable) {
      el.disabled = true;
      const wrapper = el.closest('label, .swatch, .variant-input-wrap') || el;
      wrapper.style.opacity = '0.35';
      wrapper.style.textDecoration = 'line-through';
      wrapper.title = 'Sold Out';
    }
  });
});